import styled, { css } from "styled-components";

import { COLORS, Typography } from "@treelab/panda";

export const Container = styled.div``;

export const TopContainer = styled.div<{ type: "text" | "select" | "none" }>`
  /* margin-top: 8px; */
  padding: 8px 0;
  margin-left: 3px;
  width: 90px;
  height: 32px;
  border-radius: 8px;
  font-size: 13px;
  line-height: 32px;
  color: ${COLORS.grey};
  user-select: none;

  ${({ type }) =>
    type === "none" &&
    css`
      display: none;
      padding: 0;
    `}
  ${({ type }) =>
    type === "text" &&
    css`
      margin-left: 8px;
    `}
  ${({ type }) => type === "select" && css``}

  .panda-input-dropdown--input {
    padding-left: 7px;
    font-size: 13px;
    line-height: 18px;
    color: ${COLORS.grey};
    background-color: transparent;
  }
`;

export const MainContainer = styled.div`
  display: flex;
  align-items: stretch;
`;

export const LeftContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 3px;
  border-radius: 1px;
  background-color: ${COLORS.greyLight4};
  margin-right: 10px;
  margin-left: 3px;
  color: #e0e1e6;
`;

export const RemoveItem = styled.span`
  cursor: pointer;

  &:hover {
    color: rgb(247, 99, 104);
  }
`;

export const RightContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
`;

export const Item = styled.div<{ type: "column" | "condition" | "value" }>`
  height: 32px;

  ${({ type }) => {
    switch (type) {
      case "column":
        return css`
          margin-bottom: 8px;
          width: 272px;
          flex-shrink: 0;
          flex-grow: 1;
        `;
      case "condition":
        return css`
          width: 132px;
        `;
      case "value":
        return css`
          width: 132px;
          height: unset;
        `;
    }
  }}
`;

export const Error = styled.div`
  color: ${COLORS.red};
  margin-top: 4px;
`;
